/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tree_Type_163_TitleInputs */

const en_tree_type_163_title = /** @type {(inputs: Tree_Type_163_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planet Guardian`)
};

const ar_tree_type_163_title = /** @type {(inputs: Tree_Type_163_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حارس الكوكب`)
};

const de_tree_type_163_title = /** @type {(inputs: Tree_Type_163_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planet Guardian`)
};

const es_tree_type_163_title = /** @type {(inputs: Tree_Type_163_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardián del planeta`)
};

const fr_tree_type_163_title = /** @type {(inputs: Tree_Type_163_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gardien de la Planète`)
};

const it_tree_type_163_title = /** @type {(inputs: Tree_Type_163_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardiano del pianeta`)
};

const ja_tree_type_163_title = /** @type {(inputs: Tree_Type_163_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プラネット・ガーディアン`)
};

const ko_tree_type_163_title = /** @type {(inputs: Tree_Type_163_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`행성 수호자`)
};

const pt_br_tree_type_163_title = /** @type {(inputs: Tree_Type_163_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardiã do Planeta`)
};

const ru_tree_type_163_title = /** @type {(inputs: Tree_Type_163_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хранитель планеты`)
};

const th_tree_type_163_title = /** @type {(inputs: Tree_Type_163_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ผู้พิทักษ์โลก`)
};

const tr_tree_type_163_title = /** @type {(inputs: Tree_Type_163_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gezegen Koruyucusu`)
};

const zh_cn_tree_type_163_title = /** @type {(inputs: Tree_Type_163_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`守星木`)
};

const zh_tw_tree_type_163_title = /** @type {(inputs: Tree_Type_163_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`守星木`)
};

/**
* | output |
* | --- |
* | "Planet Guardian" |
*
* @param {Tree_Type_163_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const tree_type_163_title = /** @type {((inputs?: Tree_Type_163_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tree_Type_163_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tree_type_163_title(inputs)
	if (locale === "ar") return ar_tree_type_163_title(inputs)
	if (locale === "de") return de_tree_type_163_title(inputs)
	if (locale === "es") return es_tree_type_163_title(inputs)
	if (locale === "fr") return fr_tree_type_163_title(inputs)
	if (locale === "it") return it_tree_type_163_title(inputs)
	if (locale === "ja") return ja_tree_type_163_title(inputs)
	if (locale === "ko") return ko_tree_type_163_title(inputs)
	if (locale === "pt_br") return pt_br_tree_type_163_title(inputs)
	if (locale === "ru") return ru_tree_type_163_title(inputs)
	if (locale === "th") return th_tree_type_163_title(inputs)
	if (locale === "tr") return tr_tree_type_163_title(inputs)
	if (locale === "zh_cn") return zh_cn_tree_type_163_title(inputs)
	return zh_tw_tree_type_163_title(inputs)
});